/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../buttons/button/button.component.ngfactory';
import * as import4 from '@angular/common';
import * as import5 from '../buttons/button/button.component';
import * as import6 from '../orchestration/session.model';
import * as import7 from '../orchestration/responsive.service';
import * as import8 from '../buttons/icon-button/icon-button.component.ngfactory';
import * as import9 from '../buttons/icon-button/icon-button.component';
import * as import10 from '../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import11 from '../page-layout/modal-page-layout/modal-page-layout.component';
import * as import12 from '../orchestration/page';
import * as import13 from '../orchestration/navigation.service';
import * as import14 from './nav-menu-page.component';
import * as import15 from '../ui-elements/chewzie-logo/chewzie-logo.component.ngfactory';
import * as import16 from '../ui-elements/chewzie-logo/chewzie-logo.component';
import * as import17 from '../legal/legal-panel/legal-panel.component.ngfactory';
import * as import18 from '../legal/legal-panel/legal-panel.component';
import * as import19 from '../orchestration/analytics.service';
import * as import20 from '../ordering-context/ordering-context.model';
import * as import21 from '../identity/identity.model';
import * as import22 from '../orchestration/session.controller';
import * as import23 from '@fedelta-pos/data-client/configuration/local-configuration.service';
import * as import24 from '../customer-info/customer-details.service';
const styles_NavMenuPageComponent:any[] = ([] as any[]);
export const RenderType_NavMenuPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_NavMenuPageComponent,
  data: {}
}
);
function View_NavMenuPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'nav-menu-identity-greeting'
      ]
      ],[[
        2,
        'standalone',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpod(['name']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.identityModel.isGuestUser;
    ck(v,0,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform('woa.heading.nav-menu.greeting',ck(v,2,0,co.profileName)));
    ck(v,1,0,currVal_1);
  });
}
function View_NavMenuPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[
      [
        'class',
        'nav-menu-identity-button'
      ]
      ,
      [
        'id',
        'login-button'
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.login()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import3.View_ButtonComponent_0,import3.RenderType_ButtonComponent)),
    import0.ɵdid(278528,(null as any),0,import4.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['full-width']),
    import0.ɵdid(245760,(null as any),0,import5.ButtonComponent,[
      import0.ElementRef,
      import6.SessionModel,
      import0.ChangeDetectorRef,
      import7.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'nav-menu-identity-button';
    const currVal_28:any = ck(v,2,0,!co.identityModel.supportsRegistration);
    ck(v,1,0,currVal_27,currVal_28);
    const currVal_29:any = 'woa.button.nav-menu.login';
    const currVal_30:any = (co.identityModel.supportsRegistration? co.ButtonProminence.LOW: co.ButtonProminence.HIGH);
    ck(v,3,0,currVal_29,currVal_30);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,3).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,3).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,3).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,3).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,3).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,3).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,3).disabled;
    const currVal_8:any = import0.ɵnov(v,3).invisible;
    const currVal_9:any = import0.ɵnov(v,3).hovered;
    const currVal_10:any = import0.ɵnov(v,3).native;
    const currVal_11:any = import0.ɵnov(v,3).button;
    const currVal_12:any = import0.ɵnov(v,3).firstTier;
    const currVal_13:any = import0.ɵnov(v,3).secondTier;
    const currVal_14:any = import0.ɵnov(v,3).highProminence;
    const currVal_15:any = import0.ɵnov(v,3).lowProminence;
    const currVal_16:any = import0.ɵnov(v,3).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,3).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,3).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,3).squareShape;
    const currVal_20:any = import0.ɵnov(v,3).roundedShape;
    const currVal_21:any = import0.ɵnov(v,3).ovalShape;
    const currVal_22:any = import0.ɵnov(v,3).flatStyle;
    const currVal_23:any = import0.ɵnov(v,3).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,3).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,3).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,3).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_NavMenuPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[
      [
        'class',
        'nav-menu-identity-button'
      ]
      ,
      [
        'id',
        'register-button'
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.register()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import3.View_ButtonComponent_0,import3.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import5.ButtonComponent,[
      import0.ElementRef,
      import6.SessionModel,
      import0.ChangeDetectorRef,
      import7.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.nav-menu.register';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_NavMenuPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[
      [
        'class',
        'nav-menu-identity-button'
      ]
      ,
      [
        'id',
        'logout-button'
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.logout()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import3.View_ButtonComponent_0,import3.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import5.ButtonComponent,[
      import0.ElementRef,
      import6.SessionModel,
      import0.ChangeDetectorRef,
      import7.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]
      ,
      connotation: [
        2,
        'connotation'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.nav-menu.logout';
    const currVal_28:any = co.ButtonProminence.LOW;
    const currVal_29:any = co.ButtonConnotation.DISSUASIVE;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_NavMenuPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'nav-menu-identity'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.profileName;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.identityModel.isGuestUser;
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.identityModel.isGuestUser && co.identityModel.supportsRegistration);
    ck(v,9,0,currVal_2);
    const currVal_3:boolean = !co.identityModel.isGuestUser;
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_NavMenuPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'profile-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.profile()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.profile()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.profile'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'password-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.changePassword()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changePassword()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.password'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'cards-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.loyaltyCards()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.loyaltyCards()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.loyalty-cards'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'stores-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.stores()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.stores()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.stores'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'current-store-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.currentStore()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpod(['storeName']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.currentStore()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,8,0,currVal_4);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,5).transform(co.currentStoreLabel,ck(v,4,0,(co.orderingContextModel.singleStoreLocation? co.orderingContextModel.singleStoreLocation.storeName: co.orderingContextModel.currentStore.name))));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,8).type;
    const currVal_2:any = import0.ɵnov(v,8).disabled;
    const currVal_3:any = import0.ɵnov(v,8).unavailable;
    ck(v,7,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'feedback-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.feedback()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.feedback()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.feedback'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'rate-app-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.rateApp()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.rateApp()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.IconButtonType.FORWARD;
    ck(v,7,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.nav-menu.rateApp'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).type;
    const currVal_2:any = import0.ɵnov(v,7).disabled;
    const currVal_3:any = import0.ɵnov(v,7).unavailable;
    ck(v,6,0,currVal_1,currVal_2,currVal_3);
  });
}
function View_NavMenuPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'nav-menu-footer-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.DateTime.formatDateTimeForDisplay(co.sessionModel.now);
    ck(v,1,0,currVal_0);
  });
}
function View_NavMenuPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'nav-menu-footer-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.version;
    ck(v,1,0,currVal_0);
  });
}
export function View_NavMenuPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),73,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import10.View_ModalPageLayoutComponent_0,import10.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import11.ModalPageLayoutComponent,[
      import12.Page,
      import13.NavigationService
    ]
    ,{
      closeButtonAlignment: [
        0,
        'closeButtonAlignment'
      ]
      ,
      backgroundColorPair: [
        1,
        'backgroundColorPair'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import12.PageLayout,(null as any),[import11.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,66,'div',[[
        'class',
        'nav-menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),42,'div',[[
        'class',
        'nav-menu-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'orders-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.NavMenuPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.orders()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.NavMenuPageComponent = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orders()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'nav-menu-options-option'
      ]
      ,
      [
        'id',
        'deals-option'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.NavMenuPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.deals()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'nav-menu-options-option-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'nav-menu-options-option-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.NavMenuPageComponent = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.deals()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_IconButtonComponent_0,import8.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import9.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'nav-menu-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'nav-menu-footer-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-chewzie-logo',([] as any[]),(null as any),(null as any),(null as any),import15.View_ChewzieLogoComponent_0,import15.RenderType_ChewzieLogoComponent)),
    import0.ɵdid(49152,(null as any),0,import16.ChewzieLogoComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[[
        'class',
        'nav-menu-footer-legal'
      ]
      ],(null as any),[[
        (null as any),
        'onLinkOpened'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.NavMenuPageComponent = v.component;
      if (('onLinkOpened' === en)) {
        const pd_0:any = ((<any>co.dismiss()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_LegalPanelComponent_0,import17.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import18.LegalPanelComponent,[
      import19.AnalyticsService,
      import13.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },{onLinkOpened: 'onLinkOpened'}),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavMenuPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import14.NavMenuPageComponent = v.component;
    const currVal_0:any = co.containerComponentRef.instance.pageSpec.geometry.alignment;
    const currVal_1:any = 'panel';
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = co.identityModel.allowMemberLogin;
    ck(v,10,0,currVal_2);
    const currVal_3:boolean = (!co.identityModel.isGuestUser || ((co.customerDetails == null)? (null as any): co.customerDetails.populated));
    ck(v,15,0,currVal_3);
    const currVal_4:boolean = (!co.identityModel.isGuestUser && !co.sessionModel.currentApp.integratedLoyalty);
    ck(v,18,0,currVal_4);
    const currVal_5:boolean = !co.identityModel.isGuestUser;
    ck(v,21,0,currVal_5);
    const currVal_10:any = co.IconButtonType.FORWARD;
    ck(v,30,0,currVal_10);
    const currVal_15:any = co.IconButtonType.FORWARD;
    ck(v,40,0,currVal_15);
    const currVal_16:any = (co.orderingContextModel.canChangeStore && ((co.orderingContextModel.stores == null)? (null as any): co.orderingContextModel.stores.length));
    ck(v,44,0,currVal_16);
    const currVal_17:any = (co.orderingContextModel.currentStore || co.orderingContextModel.singleStoreLocation);
    ck(v,47,0,currVal_17);
    const currVal_18:any = co.showFeedback;
    ck(v,50,0,currVal_18);
    const currVal_19:any = co.showRateApp;
    ck(v,53,0,currVal_19);
    const currVal_20:any = 'nav-menu';
    ck(v,65,0,currVal_20);
    const currVal_21:any = co.sessionModel.timeTestMode;
    ck(v,68,0,currVal_21);
    const currVal_22:any = (co.version !== '0.0.0');
    ck(v,71,0,currVal_22);
  },(ck,v) => {
    const currVal_6:any = import0.ɵunv(v,26,0,import0.ɵnov(v,27).transform('woa.label.nav-menu.orders'));
    ck(v,26,0,currVal_6);
    const currVal_7:any = import0.ɵnov(v,30).type;
    const currVal_8:any = import0.ɵnov(v,30).disabled;
    const currVal_9:any = import0.ɵnov(v,30).unavailable;
    ck(v,29,0,currVal_7,currVal_8,currVal_9);
    const currVal_11:any = import0.ɵunv(v,36,0,import0.ɵnov(v,37).transform('woa.label.nav-menu.deals'));
    ck(v,36,0,currVal_11);
    const currVal_12:any = import0.ɵnov(v,40).type;
    const currVal_13:any = import0.ɵnov(v,40).disabled;
    const currVal_14:any = import0.ɵnov(v,40).unavailable;
    ck(v,39,0,currVal_12,currVal_13,currVal_14);
  });
}
function View_NavMenuPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-nav-menu-page',([] as any[]),(null as any),(null as any),(null as any),View_NavMenuPageComponent_0,RenderType_NavMenuPageComponent)),
    import0.ɵdid(49152,(null as any),0,import14.NavMenuPageComponent,[
      import6.SessionModel,
      import20.OrderingContextModel,
      import21.IdentityModel,
      import22.SessionController,
      import13.NavigationService,
      import7.ResponsiveService,
      import23.LocalConfigurationService,
      import19.AnalyticsService,
      import24.CustomerDetailsService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import12.Page,(null as any),[import14.NavMenuPageComponent])
  ]
  ,(null as any),(null as any));
}
export const NavMenuPageComponentNgFactory:import0.ComponentFactory<import14.NavMenuPageComponent> = import0.ɵccf('woa-nav-menu-page',import14.NavMenuPageComponent,View_NavMenuPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/nav-menu/nav-menu-page.component.ngfactory.ts